import { useContext } from 'react';
import { useEffect } from 'react';
import { AutoShipContext } from '../App';
import FailureImage from '../assets/cancel.png';

const PaymentFailure = () => {

    const { autoShipDetails } = useContext(AutoShipContext);

    useEffect(() => {
        setTimeout(() => {
            // redirectToMerchant();
        },5000);
        // eslint-disable-next-line
    },[]);

    const redirectToMerchant = () => {
        var url = (autoShipDetails?.redirectUrl) + ((autoShipDetails?.redirectUrl.indexOf('?') >= 0) ? '&' : '?') + 'status=FAILURE';
        window.open(url , "_self");
    }

    return (
        <div className="listViewDiv">
            <div className="bodyWidth">
                <div className="SuccessScreen">
                    <div>
                        <img className="" src={FailureImage} alt="success" />
                        <h5>{(autoShipDetails?.errorMessage) ? autoShipDetails?.errorMessage : "Autoship configuration Failed!"}</h5>
                        <p className="reference">Transaction Reference: {autoShipDetails?.requestReference}</p>
                        
                        <p>We aren't able to process your payment. Please try again.</p>

                        <small onClick={() => redirectToMerchant()} className="link">Return to merchant</small>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentFailure;